export default {
    messages: {
        messagesPost: {
            smsCounter: true
        }
    }
}